import React, { useState } from 'react';
import { HelpCircle } from 'lucide-react';

/**
 * InfoTooltip Component
 * A reusable tooltip component for displaying helpful information
 */
const InfoTooltip = ({ content, isDark, position = 'top' }) => {
  const [isVisible, setIsVisible] = useState(false);

  const positionClasses = {
    top: 'bottom-full left-1/2 -translate-x-1/2 mb-2',
    bottom: 'top-full left-1/2 -translate-x-1/2 mt-2',
    left: 'right-full top-1/2 -translate-y-1/2 mr-2',
    right: 'left-full top-1/2 -translate-y-1/2 ml-2'
  };

  return (
    <div className="relative inline-block">
      <button
        type="button"
        onMouseEnter={() => setIsVisible(true)}
        onMouseLeave={() => setIsVisible(false)}
        onFocus={() => setIsVisible(true)}
        onBlur={() => setIsVisible(false)}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setIsVisible(!isVisible);
        }}
        className={`p-0.5 rounded-full transition-colors ${
          isDark
            ? 'text-gray-400 hover:text-gray-300 hover:bg-gray-700'
            : 'text-gray-500 hover:text-gray-700 hover:bg-gray-100'
        }`}
        aria-label="More information"
      >
        <HelpCircle className="w-4 h-4" />
      </button>

      {isVisible && (
        <>
          {/* Backdrop for mobile - clicking outside dismisses */}
          <div
            className="fixed inset-0 z-40 sm:hidden"
            onClick={(e) => {
              e.stopPropagation();
              setIsVisible(false);
            }}
          />

          {/* Tooltip content */}
          <div
            className={`absolute z-50 w-64 sm:w-72 p-3 rounded-lg border shadow-lg ${positionClasses[position]} ${
              isDark
                ? 'bg-gray-900 border-gray-700 text-gray-300'
                : 'bg-white border-gray-200 text-gray-700'
            }`}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="text-xs sm:text-sm leading-relaxed">{content}</div>

            {/* Arrow */}
            <div
              className={`absolute w-2 h-2 rotate-45 ${
                isDark ? 'bg-gray-900 border-gray-700' : 'bg-white border-gray-200'
              } ${
                position === 'top'
                  ? 'bottom-[-5px] left-1/2 -translate-x-1/2 border-r border-b'
                  : position === 'bottom'
                  ? 'top-[-5px] left-1/2 -translate-x-1/2 border-l border-t'
                  : position === 'left'
                  ? 'right-[-5px] top-1/2 -translate-y-1/2 border-t border-r'
                  : 'left-[-5px] top-1/2 -translate-y-1/2 border-b border-l'
              }`}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default InfoTooltip;
